import React, { useState } from 'react'
import PropTypes from 'prop-types'
import HouseHidePlacedItemsButton from 'src/components/house/HouseHidePlacedItemsButton'
import { HouseItemCard } from 'src/components/house/HouseItemCard'
import { CategoryButtonGroup } from 'src/components/house/CategoryButtonGroup'

import 'src/pages/main/house/scrollbar.css'

export const HouseItemsPanel = ({
  categories,
  selectedCategory,
  onCategoryChange,
  filteredItems,
  selectedItemId,
  onItemSelect,
  onBackgroundSelect,
  editingBackgroundItem,
  onConceptSelect,
  editingConceptItem,
  ghostItem,
  onPlaceGhost
}) => {
  const [isHide, setIsHide] = useState(false)

  const displayedItems = isHide ? filteredItems.filter((item) => !item.pinned) : filteredItems

  return (
    <div className="w-full h-full z-20 bg-cream flex flex-col border-4 border-stone-gray font-ShinMaruGo rounded-t-[20px]">
      <div className="w-full h-full flex flex-col flex-1 min-h-0">
        <div className="flex flex-shrink-0 w-full border-b-[3px] border-house-pink">
          <div className="flex gap-1 items-center h-full px-2 py-2 rounded-tl-[16px] bg-house-pink bg-pat01">
            <span className="pl-1 text-white text-sm xs:text-lg tracking-wider font-semibold">
              レイアウト
            </span>
            <span className="px-2 py-0.5 text-xs text-house-pink bg-cream rounded-full">
              選択グループ：{categories.find((cat) => cat.key === selectedCategory)?.label || ''}
            </span>
          </div>
          <div className="flex flex-1 text-right items-center justify-end mx-1">
            <HouseHidePlacedItemsButton
              isHide={isHide}
              setIsHide={() => setIsHide((prev) => !prev)}
            />
          </div>
        </div>

        <div className="w-full flex flex-1 flex-col items-center gap-2 py-2 bg-pat02 min-h-0">
          <div className="scale-50 xs:scale-[0.6] origin-center -my-2">
            <CategoryButtonGroup
              categories={categories}
              selectedCategory={selectedCategory}
              onCategoryChange={onCategoryChange}
            />
          </div>
          <div className="w-[95%] pl-3 pr-2 py-2 flex-1 flex justify-start rounded-[10px] bg-cream-gray border-[3px] border-stone-gray overflow-hidden">
            <div
              data-house-scroll-allow="true"
              className="w-full pr-2 overflow-auto scrollbar-custom"
            >
              <div className="grid grid-cols-3 gap-2">
                {displayedItems.map((item) => (
                  <HouseItemCard
                    key={item.id}
                    item={item}
                    selectedItemId={selectedItemId}
                    onItemSelect={onItemSelect}
                    isDisabled={!!editingBackgroundItem || !!editingConceptItem || !!ghostItem}
                    onBackgroundSelect={onBackgroundSelect}
                    onConceptSelect={onConceptSelect}
                    onPlaceGhost={onPlaceGhost}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

HouseItemsPanel.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedCategory: PropTypes.string.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  filteredItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      icon_url: PropTypes.string.isRequired,
      pinned: PropTypes.bool
    })
  ).isRequired,
  selectedItemId: PropTypes.number,
  onItemSelect: PropTypes.func,
  onBackgroundSelect: PropTypes.func,
  editingBackgroundItem: PropTypes.object,
  onConceptSelect: PropTypes.func,
  editingConceptItem: PropTypes.object,
  ghostItem: PropTypes.object,
  onPlaceGhost: PropTypes.func
}
